import styled from 'styled-components';

import { QuizBlockRoot } from './quizBlock.styles';

export const LoaderRoot = styled(QuizBlockRoot)`
  .loader-stages {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }

  .loader-stage-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
    font-size: 15px;
    font-weight: 600;
  }

  .loader-stage.is-pending .loader-stage-head {
    opacity: 0.45;
  }

  .loader-stage-value {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-variant-numeric: tabular-nums;
    color: var(--quiz-accent, var(--quiz-accent-fallback));
  }

  .loader-check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--quiz-accent, var(--quiz-accent-fallback));
    color: #ffffff;
  }

  .loader-track {
    height: 8px;
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.08);
    overflow: hidden;
  }

  .loader-fill {
    height: 100%;
    border-radius: 999px;
    background: var(--quiz-accent, var(--quiz-accent-fallback));
    transition: width 0.12s linear;
  }

  .loader-testimonial {
    position: relative;
    min-height: 120px;
    padding: 18px 18px 16px;
    overflow: hidden;
  }

  .loader-quote {
    animation: loader-fade-in 0.45s ease;
  }

  .loader-stars {
    margin-bottom: 8px;
    color: #f5b301;
    font-size: 15px;
    letter-spacing: 2px;
  }

  .loader-quote-text {
    margin: 0 0 12px;
    font-size: 14.5px;
    line-height: 1.55;
  }

  .loader-author {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13.5px;
    font-weight: 600;
  }

  .loader-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
  }

  .loader-dots {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-top: 12px;
  }

  .loader-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(15, 23, 42, 0.18);
    transition: background-color 0.2s ease, width 0.2s ease;
  }

  .loader-dot.is-active {
    width: 16px;
    border-radius: 999px;
    background: var(--quiz-accent, var(--quiz-accent-fallback));
  }

  @keyframes loader-fade-in {
    from {
      opacity: 0;
      transform: translateY(6px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }
`;
